export default {
  nodes: [
    {
      match: { object: 'block', type: 'list_item' },
      min: 1,
    },
    { match: { object: 'block', type: 'paragraph' } },
    { match: { object: 'block', type: 'unordered_list' } },
  ],
};
